<footer class="main-footer" style="padding: 0.25rem 0.75rem; font-size: 13px;">
    <span>{{'authentication.restric-area' | translate }}</span>
    <div class="float-right">
      <onertravel-version-info class="version" [version]="version" (versionClick)="versionClick($event)">
      </onertravel-version-info>
    </div>
</footer>
